import Pokestore from './assets/images/pokeStore.png';
import EmployeeManager from './assets/images/employeeManager.png';
import { v4 } from 'uuid';

interface technologie {
    id: string;
    name: string;
}

export interface Project {
    id: string;
    image: string;
    name: string;
    stack: string;
    technologies: technologie[];
    description: string;
    codeLink: string;
    siteLink: string;
}

export const ProjectData: Project[] = [
    {
        id: v4(),
        image: Pokestore,
        name: "Poke Store",
        stack: "Front-end",
        technologies: [
            { id:v4(), name: "React"},
            { id:v4(), name: "Redux"},
            { id:v4(), name: "HTML5"},
            { id:v4(), name: "Javascript"},
            { id:v4(), name: "Styled-components"},
            { id:v4(), name: "Jest"},
            { id:v4(), name: "Axios"},
            { id:v4(), name: "Material-ui"}
        ],
        description: "Projeto baseado em um e-commerce com o objetivo de trazer algumas lojas de pokemons de diferentes elementose tipos das quais os usuários podem 'comprar'. Nessa aplicação é possível que o usuário adicione um pokémon ao carrinho, deletar do carrinho, pode buscar por um nome de pokémon específico epode filtrar os pokemons, entre outras coisas.",
        codeLink: "https://github.com/Brian-Mello/PokeStore",
        siteLink: "https://pokestores.netlify.app"
    },
    {
        id: v4(),
        image: EmployeeManager,
        name: "Employee Manager",
        stack: "Full-stack",
        technologies: [
            { id:v4(), name: "HTML5"},
            { id:v4(), name: "CSS3"},
            { id:v4(), name: "Typescript"},
            { id:v4(), name: "React"},
            { id:v4(), name: "Redux"},
            { id:v4(), name: "Redux-saga"},
            { id:v4(), name: "Axios"},
            { id:v4(), name: "Material-ui"},
            { id:v4(), name: "Express"},
            { id:v4(), name: "Knex"},
            { id:v4(), name: "Hooks"}
        ],
        description: "A idéia dessa aplicação é funcionar como um gerencidor de funcionários onde o usuário pode adicionar, remover, atualizar ou ler os dados do usuários. Além disso, o usuário pode criar cargos para os funcionários descrevendo o que tal funcionário faz.",
        codeLink: "https://github.com/Brian-Mello/Employees-Manager",
        siteLink: "https://pokestores.netlify.app"
    },
]